import { DOMAIN_TYPE } from '../app/constants';
import { nationalConfigs } from './nationalConfigs';
import { bacConfigs } from './bacConfigs';

export const DOMAIN: 'national' | 'bac' =
  import.meta.env['NG_APP_DOMAIN'] || DOMAIN_TYPE.NATIONAL;

export const configsMap = {
  national: nationalConfigs,
  bac: bacConfigs,
};
